import axios from "axios";
import {FileItem} from "@/store/user_management/distr_moderation/types";

export function directDownload(uri: string, params?: any):Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      let urlLinkResponse:any = await axios({
        url: uri,
        params: params,
      })
      let link = urlLinkResponse.data.link;
      let filename = link.split('/').pop().split('#')[0].split('?')[0];
      console.log(filename)
      let fileContentResponse:any = await axios({
        url: link,
        method: 'GET',
        responseType: 'blob',
      })
      let fileURL = window.URL.createObjectURL(new Blob([fileContentResponse.data]));
      let fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

export async function readFileAsBinary(file: Blob) {
  let readPromise = new Promise<any>((resolve, reject) => {
    let fr = new FileReader();
    fr.onerror = reject;
    fr.onload = () => resolve(new Uint8Array(<ArrayBuffer>fr.result));
    fr.readAsArrayBuffer(file);
  });
  const byteArray: Uint8Array = await readPromise;
  let fileString: string = '';
  let len = byteArray.byteLength;
  for (let i = 0; i < len; i++) {
    fileString += String.fromCharCode(byteArray[i]);
  }
  return fileString
}

export async function readFileAsText(file: Blob) {
let readPromise = new Promise<any>((resolve, reject) => {
  let fr = new FileReader();
  fr.onerror = reject;
  fr.onload = () => resolve(fr.result);
  fr.readAsText(file);
});
return await readPromise;
}

export function downloadBase64ToFile(file: FileItem): void{
  if (file && Object.keys(file).length !== 0){
    const linkSource: string = `data:application/pdf;base64,${file.base64}`;
    const downloadLink = document.createElement("a");
    const fileName: string = file.name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
}
